export const footerData = {
    links: [
        {
            id: 1,
            title: 'home',
            href: '/'
        },
        {
            id: 2,
            title: 'services',
            href: '/#review-section'
        },
        {
            id: 3,
            title: 'how it works',
            href: '/#how-it-works'
        },
        {
            id: 4,
            title: 'news & reports',
            href: '/#news-report'
        },
        {
            id: 5,
            title: 'privacy policy',
            href: '/privacy-policy'
        }
    ],
    footerDetail: [
        {
            id: 1,
            text: 'GIT Global assists with immigration application preparation but does not provide legal advice. We are not a law firm and are not affiliated with USCIS or any government agency. Our services do not have the regulatory oversight of licensed attorneys. For specific legal advice, please consult a licensed attorney. Blank immigration forms and instructions are available for free on the USCIS website. Use of GIT Global’s services is subject to our Privacy Policy and Terms of Use.'
        }
    ],
    contactInfo: [
        {
            id: 1,
            image: 'images/office.svg',
            text: '2 E. Benton St, Iowa City, IA, 52240',
            href: 'https://maps.app.goo.gl/wJFaM49UjfzfVcVR7',
        },
        {
            id: 2,
            image: 'images/call.svg',
            text: '515-446-7074',
            href: 'tel:+15154467074',
        },
        {
            id: 3,
            image: 'images/mail.svg',
            text: 'info@gitsiowa.com',
            href: 'mailto:info@gitsiowa.com',
        },
    ],
    socialMedia: [
        {
            id: 1,
            image: 'images/facebook-icon.svg' ,
            url: 'https://www.facebook.com/GITS2020/' ,
            alt: 'facebook icon' ,
        },
        {
            id: 2,
            image: 'images/instagram-icon.svg' ,
            url: 'https://www.instagram.com/git.global?igsh=cnphaTh6bGdnOHVo' ,
            alt: 'instagram icon' ,
        },
        {
            id: 3,
            image: 'images/tiktok-icon.svg' ,
            url: 'https://www.tiktok.com/@gitglobal51?is_from_webapp=1&sender_device=pc' ,
            alt: 'tiktok icon' ,
        },
    ],
}